import type { Corners } from "@/libs/models";

const createBboxFromCorners = (corners: Corners) => {
  const lats = corners
    .toArray()
    .map((x) => x.lat)
    .sort((a, b) => a - b);
  const lngs = corners
    .toArray()
    .map((x) => x.lng)
    .sort((a, b) => a - b);

  return [
    lngs.at(0), // minX
    lats.at(0), // minY
    lngs.at(-1), // maxX
    lats.at(-1), // maxY
  ] as [number, number, number, number];
};

export const autofillGeoserverQueryParams = (
  urlString: string,
  buildingWidth: number,
  buildingLength: number,
  corners: Corners,
): { bbox: [number, number, number, number]; url: string } => {
  const url = new URL(urlString);

  // Bounding box
  const bbox = createBboxFromCorners(corners);
  url.searchParams.delete("bbox");
  url.searchParams.set("bbox", bbox.join(","));
  url.searchParams.set("srs", "EPSG:4326");

  // Transparent
  const transparent = url.searchParams.get("transparent");
  if (transparent == null) {
    url.searchParams.set("transparent", "true");
  }

  // Width & height
  const paramsHeight = url.searchParams.get("height");
  const paramsWidth = url.searchParams.get("width");

  if (!paramsHeight && !paramsWidth) {
    url.searchParams.set("height", Math.floor(buildingLength).toString());
    url.searchParams.set("width", Math.floor(buildingWidth).toString());
  } else if (!paramsHeight) {
    const buildingRatio = buildingLength / buildingWidth;
    url.searchParams.set(
      "height",
      Math.floor(
        parseInt(url.searchParams.get("width")!) * buildingRatio,
      ).toString(),
    );
  } else if (!paramsWidth) {
    const buildingRatio = buildingWidth / buildingLength;
    url.searchParams.set(
      "width",
      Math.floor(
        parseInt(url.searchParams.get("height")!) * buildingRatio,
      ).toString(),
    );
  }

  return {
    bbox: bbox,
    url: url.toString(),
  };
};
